import SnBtn from '~/components/snui/snBtn/snBtn'

export default {
  SnBtn
}
